import React, { useState } from "react"
import { Link } from "react-router-dom"
import "./Footer.css"
import HelpCenterModal from "./modals/HelpCenterModal"

export default function Footer() {
  const [hcModal,sethcModal] = useState(false)

  const cancelModal = () => {
    sethcModal(false)
  }
  return (
    <footer className="footerWrap">
{ hcModal &&     <HelpCenterModal  cancelModal={cancelModal}/>}
      <div className="footerTop" />

      <div className="container py-5">
        <div className="row g-4">
          <div className="col-12 col-md-4">
            <div className="footerBrand">Neurodiverse Therapy</div>
            <div className="footerText">
              Helping neurodivergent minds find understanding, support, and the
              right therapist.
            </div>
          </div>

          <div className="col-6 col-md-2">
            <div className="footerTitle">Support</div>
            <ul className="footerList">
              <li onClick={() => sethcModal(true)}>Help Centre</li>
            </ul>
          </div>
        </div>

        <div className="footerBottom mt-4">
          <div>© {new Date().getFullYear()} Neurodiverse Therapy</div>
          <div className="footerLegal">
            <Link to="/privacy" className="text-white text-decoration-none">
              Privacy Policy
            </Link>
            <span className="mx-2">•</span>
            <Link to="/terms" className="text-white text-decoration-none">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}